const entry = {
  secure: '企業スペースを確認済み',
  title: '入力のやり直しではなく、企業の真実から始めます。',
  body: 'この招待に属する企業プロジェクトを確認しました。前回のプロジェクトを続けるか、新しい市場目標の診断を開始できます。',
  identity: '現在の招待ID',
  changeEmail: '別のメールでログイン',
  signingOut: 'ログアウト中…',
  signOutFailed: 'ログアウトできませんでした。接続を確認して再試行してください。',
  existingTitle: 'プロジェクトに戻る',
  existingBody: '前回のプロジェクトを既定で選択',
  projectCount: '{count}件のプロジェクト',
  ready: '準備完了',
  continueSetup: '設定を続ける',
  targetMarkets: '対象市場',
  lastOpened: '最終アクセス',
  noMarkets: '未設定',
  viewProjects: '既存プロジェクトを見る',
  startDiagnosis: '新しい診断を開始',
  serverTruth: 'プロジェクト一覧はサーバーが真実です。この端末は前回の選択だけを記憶します。',
  emptyTitle: '最初のプロジェクトを作成',
  emptyHint: 'この招待にはまだ企業プロジェクトがありません',
  emptyLead: '4ステップで企業設定を完了',
  emptyBody: '企業・製品情報、対象市場、公開リンク、プロジェクト資料を追加し、診断範囲を確認します。',
  emptyNote: '資料の確認前は保存して終了できます。',
}

export default entry
